import Vue from "vue";
import Router from "vue-router";
import jwtService from "./core/services/jwt.service";
Vue.use(Router);
function checkStandalone(to, from, next) {
  const isStandalone = jwtService.getStandalone();

  if (isStandalone == "true") {
    next();
  } else {
    next("/dashboard");
  }
}

export const router = new Router({
  routes: [
    {
      path: '/',
      name: 'landing',
      component: () => import ('@/view/pages/landing/LandingPage.vue')
      
    },
    /* {
      path: '/logout',
      name: 'logout',
      component: () => import ('@/components/LogOut.vue')
      
    }, */
    {
      path: '/virtualLogin',
      name: 'virtualLogin',
      component: () => import ('@/view/pages/virtualLogin/virtualLoginPage.vue')
    },
    {
      path: '/dischargeloadsequencing/:id',
      name: 'dischargeloadsequencing',
      component: () => import ('@/view/pages/dischargeloadsequencing/DischargeLoadSequencingView.vue'),
      meta: {
        requiresAuth: true // Add meta field to indicate protected route
      }
    },
    {
      path: '/stowageinstruction/:id',
      name: 'stowageinstruction',
      component: () => import ('@/view/pages/stowageinstruction/StowageInstructionPage.vue'),
      meta: {
        requiresAuth: true // Add meta field to indicate protected route
      }
    },
     {
      path: '/stowageinstruction/edit/:vid/:sid/:fid/:pid',
      name: 'stowageinstructionEdit',
      component: () => import ('@/view/pages/stowageinstruction/StowageInstructionEdit.vue'),
      meta: {
        requiresAuth: true // Add meta field to indicate protected route
      }
    },
    {
      path: '/stowageinstruction/detail/:vid/:sid',
      name: 'stowageinstructionDetail',
      component: () => import ('@/view/pages/stowageinstruction/StowageInstructionView.vue'),
      meta: {
        requiresAuth: true // Add meta field to indicate protected route
      }
    },
    {
      path: '/vessel-monitoring/:id',
      name: 'vessel monitoring',
      component: () => import ('@/view/pages/vesselMonitoring/VesselMonitoringPage.vue'),
      meta: {
        requiresAuth: true // Add meta field to indicate protected route
      }
    },
    {
      path: '/vessel-profile/:id',
      name: 'vessel profile',
      component: () => import ("@/view/pages/vesselProfile/vesselProfile.vue"),
      meta: {
        requiresAuth: true // Add meta field to indicate protected route
      }
    },
    {
      path: '/qcworkingplan/:id',
      name: 'qcworkingplan',
      component: () => import ("@/view/pages/QC/vesselProfile.vue"),
      meta: {
        requiresAuth: true // Add meta field to indicate protected route
      }
    },
    {
      path: "/custom-error",
      name: "error",
      component: () => import("@/view/pages/error/Error.vue"),
      children: [
        {
          path: "error-1",
          name: "error-1",
          component: () => import("@/view/pages/error/UnAuthorized.vue"),
        },
        {
          path: "error-2",
          name: "error-2",
          component: () => import("@/view/pages/error/Error-2.vue"),
        },
        {
          path: "error-3",
          name: "error-3",
          component: () => import("@/view/pages/error/Error-3.vue"),
        },
        {
          path: "error-4",
          name: "error-4",
          component: () => import("@/view/pages/error/Error-4.vue"),
        },
        {
          path: "error-5",
          name: "error-5",
          component: () => import("@/view/pages/error/Error-5.vue"),
        },
        {
          path: "error-6",
          name: "error-6",
          component: () => import("@/view/pages/error/Error-6.vue"),
        },
      ],
    },
    {
      path: "/berthplanningSVG",
      name: "berthplanningSVG",
      component: () =>
        import("@/view/pages/berthplanning/BerthPlanningSVG.vue"),
      meta: {
        requiresAuth: true // Add meta field to indicate protected route
      }
    },
    {
      path: "/berthmonitoring",
      name: "berthmonitoring",
      component: () =>
        import("@/view/pages/berthmonitoring/BerthMonitoring.vue"),
      meta: {
        requiresAuth: true // Add meta field to indicate protected route
      }
    },
    {
      path: "*",
      redirect: "/404",
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/Error-1.vue"),
    },
    {
      // the 404 route, when none of the above matches
      path: "/401",
      name: "401",
      component: () => import("@/view/pages/error/UnAuthorized.vue"),
    },
  ],
});
